import { Component } from "@angular/core";
import { Title } from "@angular/platform-browser";
import {
  Router,
  NavigationEnd,
  ActivatedRoute,
  Data,
  RouterModule,
} from "@angular/router";
import { filter, map, mergeMap } from "rxjs/operators";
import { CommonModule } from "@angular/common";
import { CoreService } from "@assoanalytics/app/core/services/core.service";
import { BiPageDataService } from "@assoanalytics/app/modules/bi/services/bi-page-data.service";
import { Subscription, tap } from "rxjs";
import { FilterLayout } from "@assoanalytics/app/core/enum/Filters";
import { FiltersOptions } from "@assoanalytics/app/core/models/filters-model";
import { FilterInputService } from "@assoanalytics/app/shared/services/filter-input/filter-input.service";
import { provideTablerIcons, TablerIconComponent } from "angular-tabler-icons";
import { FilterBarComponent } from "@assoanalytics/app/shared/components/filter-bar/filter-bar.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
  IconChevronRight,
  IconHelpCircle,
  IconHelpOff,
} from "angular-tabler-icons/icons";

@Component({
  selector: "app-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.scss"],
  imports: [
    CommonModule,
    RouterModule,
    FilterBarComponent,
    TablerIconComponent,
    MatTooltipModule,
  ],
  providers: [
    provideTablerIcons({ IconHelpCircle, IconHelpOff, IconChevronRight }),
  ],
})
export class AppBreadcrumbComponent {
  pageInfo: Data | any = Object.create(null);

  filters: FilterLayout = [];
  filtersOptions: FiltersOptions = {};

  options = this.settings.getOptions();

  hideBreadcrumb: boolean = false;

  private biPageDataSub?: Subscription;
  private routerSubscription: Subscription;

  constructor(
    private settings: CoreService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private biPageData: BiPageDataService,
  ) {
    // Aggiorna breadcrumb al primo load
    this.updateBreadcrumb();

    // Aggiorna breadcrumb ad ogni cambio rotta
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateBreadcrumb();
      });

    FilterInputService.setPageFilters.subscribe((filters) => {
      this.filters = filters;
    });

    // Reset filtri
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.filters = [];
        FilterInputService.setPageFilters.next([]);
        this.filtersOptions = {};
      }
    });
  }

  /**
   * Aggiorna il breadcrumb e il titolo della pagina in base alla rotta corrente
   */
  private updateBreadcrumb() {
    const appName = this.options.appName || "ASSO Analytics";

    // Se la rotta inizia con /clienti-pro usa biPageData
    if (this.router.url.startsWith("/clienti-pro")) {
      this.biPageDataSub?.unsubscribe();
      this.biPageDataSub = this.biPageData.data$.subscribe((data) => {
        if (data) {
          this.titleService.setTitle(`${data.title} | ${appName}`);
          this.pageInfo = data;
        }
      });
    } else {
      // Comportamento standard: cerca il child più profondo
      this.biPageDataSub?.unsubscribe();
      let route = this.activatedRoute;
      while (route.firstChild) {
        route = route.firstChild;
      }
      if (route.outlet === "primary") {
        route.data.subscribe((event) => {
          const pageTitle = event["title"];
          this.titleService.setTitle(
            `${pageTitle ? pageTitle + " | " : ""} ${appName}`,
          );
          this.pageInfo = event;
          // Hide breadcrumb on dashboard route
          this.hideBreadcrumb = this.router.url === "/dashboard";
        });
      }
    }
  }

  ngOnDestroy() {
    this.biPageDataSub?.unsubscribe();
  }
}
